<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content class="mat-typography">Sorry, there was a problem submitting your referral. Please try again.<br>
  If you are still having problems, please let us know using the webchat.</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>